'use strict';

import { createHtmlElement } from '../../functions';

export function addPoweredLogo () {
  const {active} = config.features.bmbyLogo;
  if (!active){
    return;
  }

  const parent = document.querySelector('.aside__bottom__container');
  const container = createHtmlElement(parent,'','div',['powered__logo']);
}